export default __webpack_public_path__ + "static/media/clock-late.37358d7e.svg";